import { useInstructionInformationHandler } from '@/features/ap_payees/components/DocInstructionMenu/ExportInstructionsPdf/Contents/InstructionInformation/hooks';
import { InstructionPdfForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import {
  ButtonV2,
  Form,
  IconApproval,
  Tooltip,
} from '@moneyforward/ap-frontend-components';
import { FC } from 'react';
import { InstructionContent } from '../Forms/InstructionContent';
import { InstructionDestination } from '../Forms/InstructionDestination';
import { InstructionSender } from '../Forms/InstructionSender';
import { InstructionTemplate } from '../Forms/InstructionTemplate';
import { InstructionTitle } from '../Forms/InstructionTitle';
import styles from '../index.module.scss';

export const InstructionInformation: FC = () => {
  const {
    methods,
    hasCustomTemplate,
    onApplyCustomTemplate,
    templateTooltip,
    applyTemplateButtonLabel,
    appliedCustomTemplate,
    tooltipVisible,
  } = useInstructionInformationHandler();
  const { control } = methods;

  return (
    <Form<InstructionPdfForm>
      id='formInstructionInformation'
      testId='formInstructionInformation'
      formMethod={methods}
      onSubmit={() => {}}
    >
      <div className={styles['button-template']}>
        <Tooltip
          title={templateTooltip}
          placement='left'
          open={hasCustomTemplate ? tooltipVisible : undefined}
          trigger={!hasCustomTemplate ? ['hover'] : undefined}
        >
          <ButtonV2
            isSecondary
            leftIcon={appliedCustomTemplate ? <IconApproval /> : undefined}
            isTertiary
            isDisabled={!hasCustomTemplate}
            onClick={onApplyCustomTemplate}
          >
            {applyTemplateButtonLabel}
          </ButtonV2>
        </Tooltip>
      </div>

      <InstructionDestination control={control} />
      <InstructionSender control={control} />
      <InstructionTitle control={control} />
      <InstructionContent control={control} />
      <InstructionTemplate control={control} />
    </Form>
  );
};

InstructionInformation.displayName = 'InstructionInformation';
